import { Dropdown } from 'antd';
import type { MenuProps } from 'antd';
import React from 'react';
import type { Range } from 'slate';

import { AvatarTag } from './AvatarTag';
import styles from './index.module.scss';
import type { ITag } from './types';

interface TagMenuProps {
  tags: ITag[];
  selectedIndex: number;
  menuAnchor: Range | null;
  menuPosition: { top: string | number; left: string | number } | null;
  onSelect: (tag: ITag) => void;
}

export const TagMenu: React.FC<TagMenuProps> = ({
  tags,
  selectedIndex,
  menuAnchor,
  menuPosition,
  onSelect,
}) => {
  const menuItems: MenuProps['items'] = tags.map((tag) => ({
    key: tag.value,
    label: <AvatarTag {...tag} showBackground={false} />,
    onClick: () => {
      onSelect(tag);
    },
  }));

  if (!menuAnchor) return null;

  return (
    <Dropdown
      overlayClassName={styles.tagMenu}
      overlayStyle={{ top: menuPosition?.top, left: menuPosition?.left }}
      menu={{
        items: menuItems,
        selectedKeys: [tags[selectedIndex]?.value],
      }}
      open
      trigger={[]}
    >
      <div></div>
    </Dropdown>
  );
};
